import axios from 'axios';

export const getAddressByCEP = cep => {
    return axios.get(`https://brasilapi.com.br/api/cep/v1/${cep}`);
};
